/** Server config: ImportAccount:MaxBatchRows */
export const IMPORT_ACCOUNT_MAX_BATCH_ROWS = 200;

export const IMPORT_ACCOUNT_MAX_BULK_MAPPINGS = 200;

export const IMPORT_ACCOUNT_BATCH_EXCEEDED_MESSAGE =
  'Import batch exceeds maximum of 200 rows';
